import React, { useEffect } from 'react';

const Payments = () => {
  // Scroll to top on mount
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div className="view-section max-w-4xl">
      <h2 className="text-2xl font-bold text-dark mb-6">Payment History</h2>
      <div className="bg-white  border border-gray-100 overflow-hidden">
        <table className="w-full text-left text-sm">
          <thead className="bg-gray-50 border-b border-gray-100 text-gray-500">
            <tr>
              <th className="px-6 py-4 font-medium">Date</th>
              <th className="px-6 py-4 font-medium">Description</th>
              <th className="px-6 py-4 font-medium">Method</th>
              <th className="px-6 py-4 font-medium text-right">Amount</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-100">
            <tr>
              <td className="px-6 py-4 text-gray-600">Nov 18, 2023</td>
              <td className="px-6 py-4 font-medium text-dark">Order #QC-8832</td>
              <td className="px-6 py-4 text-gray-500">UPI</td>
              <td className="px-6 py-4 text-right font-bold text-dark">- ₹450.00</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Payments;